import { render, staticRenderFns } from "./tabMaterialsStockApparatus.vue?vue&type=template&id=dcbf9c7e&scoped=true&"
import script from "./tabMaterialsStockApparatus.vue?vue&type=script&lang=js&"
export * from "./tabMaterialsStockApparatus.vue?vue&type=script&lang=js&"
import style0 from "./tabMaterialsStockApparatus.vue?vue&type=style&index=0&lang=css&"
import style1 from "./tabMaterialsStockApparatus.vue?vue&type=style&index=1&id=dcbf9c7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcbf9c7e",
  null
  
)

export default component.exports